export default __webpack_public_path__ + "static/media/dansketext-semibolditalic.f5e6515d.woff";